module.exports = __webpack_public_path__ + "assets/totalamountdu.22edbe7d.svg";